const navbarToggler = document.querySelector(".navbar-toggler");

if (navbarToggler) {
  navbarToggler.addEventListener("click", () =>
    document.querySelector("html").classList.toggle("navbar-open")
  );
}
